import { render, staticRenderFns } from "./ChannelSettingsProvider.vue?vue&type=template&id=41fb74d3&scoped=true&"
import script from "./ChannelSettingsProvider.vue?vue&type=script&lang=js&"
export * from "./ChannelSettingsProvider.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettingsProvider.vue?vue&type=style&index=0&id=41fb74d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb74d3",
  null
  
)

export default component.exports